import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { RightHolderState } from '../types';
import RightHolderForm from '../RightHolderForm';

/**
 * AgenciesFormコンポーネント用のPropsです。
 * @interface AgenciesFormProps
 */
interface AgenciesFormProps {

  /**
   * 代理人（複数）
   * @type {RightHolder[]}
   * @memberof AgenciesFormProps
   */
  rightHolders: RightHolderState[];

  /**
   * 代理人（複数）を設定する関数
   * @memberof AgenciesFormProps
   */
  onChange: (agencies: RightHolderState[]) => void;

}

/**
 * 代理人（複数）フォームのコンポーネントです。
 * @param {string} props.agencies - 代理人（複数）
 * @param {function} props.onChange - 代理人（複数）が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 代理人（複数）フォームのJSX要素
 */
const AgenciesForm: React.FC<AgenciesFormProps> = ({ rightHolders, onChange }) => {

  /**
   * 代理人フォームを追加する関数です。
   * @param {RightHolderState} addedRightHolder - 代理人
   * @returns {void}
   */
  const addRightHolder = (addedRightHolder: RightHolderState): void => {
    onChange([...rightHolders, addedRightHolder]);
  }

  /**
   * 代理人フォームを削除する関数です。
   * @param {number} removedRightHolderIndex - 削除する代理人の索引
   * @returns {void}
   */
  const deleteRightHolder = (removedRightHolderIndex: number): void => {
    if(removedRightHolderIndex !== 0) {
      onChange(
        rightHolders.filter((_rightHolder, i) => (i !== removedRightHolderIndex))
      )
    }
  }

  /**
   * 代理人フォームを更新する関数です。
   * @param {number} updatedRightHolderIndex - 更新する代理人の索引
   * @param {string} updatedRightHolder - 更新する代理人
   * @returns {void}
   */
  const updateRightHolder = (updatedRightHolderIndex: number, updatedRightHolder: RightHolderState): void => {
      onChange(
        rightHolders.map((rightHolder, i) => (i === updatedRightHolderIndex ? updatedRightHolder : rightHolder))
      )
  }

  /** 
   * 代理人の初期値
   * @type {RightHolder}
   */
  const emptyeRightHolder: RightHolderState = {
    identificationNumber: {
      value: '',
      errorMessage: ''
    },
    address: {
      value: '',
      errorMessage: ''
    },
    name: {
      value: '',
      errorMessage: ''
    }
  };

  return (
    <>
      <Form.Label>権利者</Form.Label>
      <div className="text-end" style={{marginTop: '-2rem'}}>
        <div className="mx-1 d-inline">
          <Button
            variant="primary"
            className="rounded-circle py-1 px-2 text-white"
            size="sm"
            onClick={() => {addRightHolder(emptyeRightHolder);}}
          >
            <FaPlus />
          </Button>
        </div>
        <div className="mx-1 d-inline">
          <Button 
            variant="danger"
            className="rounded-circle py-1 px-2 text-white"
            size="sm"
            onClick={() => {deleteRightHolder(rightHolders.length-1);}}
            disabled={rightHolders.length === 1 ? true : false}
          >
            <FaMinus />
          </Button>
        </div>
      </div>
      <div style={{marginTop: '-1rem'}}>
        {rightHolders.map((rightHolder, index) => {
          return (
            <div key={index} className="my-4">
              <RightHolderForm
                index={index}
                rightHolder={rightHolder}
                onChange={updateRightHolder}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}

export default AgenciesForm;